<template>
  <v-card flat class="function-review">
    <v-card-title class="pa-0">
      <h4>Function Review</h4>
    </v-card-title>
    <v-card-text class="pa-0">
      <status-display-bar :warn-message="warningMsg" />
      <p class="mb-0">
        Review the functions that this asset has access to and make any desired
        changes
      </p>
      <div class="mb-2 functionsReviewTable">
        <sphere-table
          ref="functionsReviewTable"
          :api-endpoint="`${functionReviewEndpoint}?appRoleId=${asset._Id}`"
          :columns="tableColumns"
          :update-data-items="updateFunctionsData"
          client-side
          table-type="actionable"
          name="functionsReview"
          @selectionchange="selectionChange"
          @mounted="functionsMounted"
        >
          <template #noRecordsMsg> There are no functions to review </template>
          <template v-slot:newValueCellTemplate="{ props }">
            <td class="text-xs-center">
              <v-btn-toggle
                v-model="props.dataItem.newValue"
                mandatory
                class="my-1"
              >
                <v-btn
                  v-for="(val, idx) in accessLevels"
                  :key="idx"
                  :value="val"
                  flat
                  small
                  class="sb_btn_solid"
                  @click.stop
                  @input="
                    $emit(
                      'updated',
                      'function',
                      props.dataItem,
                      roleFunctionsList.findIndex(
                        (item) => item._id == props.dataItem._id
                      )
                    )
                  "
                >
                  {{ val }}
                </v-btn>
              </v-btn-toggle>
            </td>
          </template>
          <template v-slot:actionBtns>
            <div class="text-xs-right sb-table-top-actions">
              <v-btn
                v-for="(accessLevel, idx) in accessLevels"
                :key="idx"
                outline
                :color="accessLevel == 'Remove' ? 'error' : ''"
                class="sb_btn_solid"
                :disabled="selectedItems.length === 0"
                @click="changeSelections(accessLevel)"
              >
                {{ accessLevel }}
              </v-btn>
            </div>
          </template>
        </sphere-table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import SphereTable from '../../Table/SphereTable.vue';
import StatusDisplayBar from '../../StatusDisplayBar.vue';
import reviewStepBase from './reviewStepBase.mixin.js';

export default {
  name: 'FunctionReview',
  components: { StatusDisplayBar, SphereTable },
  mixins: [reviewStepBase],
  data() {
    return {
      functionReviewEndpoint: '/AssetReviewApi/GetAppRoleFunctions',
      selectedItems: [],
      roleFunctionsList: [],
      roleFunctionsCount: 0,
    };
  },
  computed: {
    warningMsg() {
      if (this.functionList.length === 0) {
        return 'There are no functions associated to this role';
      }
      return undefined;
    },
  },
  created() {
    this.tableColumns = [
      { field: '_id', invisible: true },
      { field: 'OwnerId', invisible: true },
      { field: 'FunctionName', defaultSort: 'asc', orderIndex: 0 },
      { field: 'FunctionDescription', orderIndex: 1 },
      {
        field: 'value',
        invisible: true,
      },
      {
        field: 'newValue',
        cell: 'newValueCellTemplate',
        orderIndex: 2,
        filterable: false,
        sortable: false,
      },
    ];
  },
  methods: {
    functionsMounted(items, totalItemsCount) {
      this.roleFunctionsList = items;
      this.roleFunctionsCount = totalItemsCount;
      this.$emit('functions-mounted', this.roleFunctionsList);
    },
    updateFunctionsData(functions) {
      return functions.map((f) => {
        return { value: 'Keep', newValue: 'Keep', ...f };
      });
    },
    changeSelections(newValue) {
      this.selectedItems.forEach((i) => {
        (i.newValue = newValue), (i.selected = false);
        // get index of item in total functions list
        let index = this.roleFunctionsList.findIndex(
          (item) => item._id == i._id
        );
        this.$emit('updated', 'function', i, index);
      });
      this.selectedItems = [];
      this.$refs.functionsReviewTable.updateHeaderSelectionValue();
    },
    selectionChange(selectedItems) {
      if (selectedItems.length > 0) {
        this.selectedItems = selectedItems;
      } else {
        this.selectedItems = [];
      }
    },
  },
};
</script>

<style>
.function-review .v-item-group > .v-btn--active {
  background-color: rgb(25, 118, 210);
  color: white;
}

.function-review table.v-table thead th.newValueHeader {
  width: 170px;
}

.function-review .sb-table-top-actions .v-btn.table_columns_shown {
  border-radius: 50%;
}
</style>
<style lang="scss">
.functionsReviewTable {
  .sphere-table-container {
    position: relative !important;
  }
  .k-grid-container {
    max-height: 258px;
  }
}
</style>
